<template>
  <div class="box">
    <div class="workbench workbench-tabs">
      <div
        class="workbench-tab-wrapper"
        :class="{ 'full-screen': isTopPanelFull }"
        v-if="!node"
      >
        <div class="workbench-tab">
          <template v-for="work in worklist">
            <div
              :key="work.id"
              :class="{ active: work.id == current }"
              class="workbench-tab-item"
              v-if="work.isShow"
            >
              <we-title
                :work="work"
                @on-choose="chooseWork"
                @on-remove="removeWork"
              />
            </div>
          </template>
          <Icon
            type="ios-add-circle-outline"
            color="#2283e2"
            size="24"
            @click="addWork"
            class="addPadding"
          />
        </div>
        <div class="workbench-tab-button">
          <Dropdown
            trigger="click"
            placement="bottom-end"
            @on-click="dropdownClick"
          >
            <Icon type="md-list" />
            <DropdownMenu slot="list">
              <DropdownItem name="other">{{
                $t("message.workBench.container.closeDropDown.others")
              }}</DropdownItem>
              <DropdownItem name="all">{{
                $t("message.workBench.container.closeDropDown.all")
              }}</DropdownItem>
              <DropdownItem name="left">{{
                $t("message.workBench.container.closeDropDown.left")
              }}</DropdownItem>
              <DropdownItem name="right">{{
                $t("message.workBench.container.closeDropDown.right")
              }}</DropdownItem>
              <DropdownItem name="fullScreen" divided v-if="!isTopPanelFull">{{
                $t("message.constants.logPanelList.fullScreen")
              }}</DropdownItem>
              <DropdownItem name="releaseFullScreen" v-else>{{
                $t("message.constants.logPanelList.releaseFullScreen")
              }}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <div
        class="workbench-container"
        :class="{ node: node }"
        v-if="workListLength > 0"
      >
        <we-body
          v-for="work in worklist"
          v-show="current == work.id"
          :key="work.id"
          :work="work"
          @remove-work="removeWork"
          :node="node"
          :readonly="readonly"
          @changeShow="show = true"
          @updateApiName="updateApiName"
          @handleismodifyByOldTab="handleismodifyByOldTab"
          @getSourceId="getSourceId"
        />
      </div>
      <!-- </template> -->
      <template v-if="workListLength == 0 && !loading">
        <div class="bg-page">
          <img class="bg-img" src="./image/bg-img.png" />
          <p
            class="bg-text"
            :class="{
              weight: line.indexOf('？') !== -1,
              indent: line.indexOf('？') === -1,
            }"
            v-for="(line, index) in tips.split('\n')"
            :key="index"
          >
            {{ line }}
          </p>
        </div>
      </template>
      <template>
        <Spin v-if="loading" size="large" fix />
      </template>
      <Modal v-model="showCloseModal" :closable="false" width="360">
        <p slot="header" class="modal-title">
          <Icon type="md-help-circle" />
          <span>{{ $t("message.workBench.container.closeHint") }}</span>
        </p>
        <div class="modal-content">
          <p style="word-break: break-all">{{ closeModal.text }}</p>
        </div>
        <div slot="footer">
          <Button type="text" @click="closeModal.cancel">{{
            $t("message.workBench.container.footer.cancel")
          }}</Button>
          <Button type="warning" @click="closeModal.close">{{
            $t("message.workBench.container.footer.close")
          }}</Button>
          <Button
            v-if="closeModal.save"
            type="primary"
            @click="closeModal.save"
            >{{ $t("message.workBench.container.footer.save") }}</Button
          >
          <Button
            v-if="closeModal.saveAs"
            type="primary"
            @click="closeModal.saveAs"
            >{{ $t("message.workBench.container.footer.saveAs") }}</Button
          >
        </div>
      </Modal>
      <save-as ref="saveAs" />
    </div>
  </div>
</template>
<script>
import storage from "@dss/js/helper/storage";
import util from "@dss/js/util";
import title from "./title.vue";
import body from "./body.vue";
import saveAs from "./script/saveAs.vue";

import { Work } from "./modal.js";
import { find, uniq, isEmpty, last, findIndex } from "lodash";
import { WORKSPACEIDKEY } from "@/api";
import { axios, methodList } from "@/api";
export default {
  components: {
    "we-body": body,
    "we-title": title,
    saveAs,
  },
  props: {
    width: Number,
    node: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      worklist: [], //所有脚本
      current: "", //当前脚本id
      lastCurrent: "", //上一个脚本id
      closeModal: {
        text: "",
        cancel: () => {},
        close: () => {},
        save: () => {},
        saveAs: () => {},
      },
      showCloseModal: false,
      // userName: "",
      tabMove: {
        maxTabLen: 0,
        leftTab: 0,
        rightTab: 0,
      },
      isControlBtnShow: false,
      isTopPanelFull: false, //是否全屏
      loading: false,
      tabIndex: 1, // 新建脚本的序号
      tips: "数据服务主要通过API的形式，给各租户产业提供快速生成服务的能力，统一管理所有生成的API，API低成本的运维。实现数据服务低代码、成本低，发布迅速，数据共享，用户只需关注API本身的内容即可。",
    };
  },
  computed: {
    workListLength() {
      //判断是否有接口展示
      return this.worklist.length;
    },
  },

  methods: {
    addWork() {
      let filename = `新建接口${this.tabIndex++}`;
      const md5Path = util.md5(filename);
      this.dispatch("Workbench:add", {
        id: md5Path,
        filename,
        saveAs: true,
        flowStatus: "",
        code: "",
        type: "apiScript",
        datasourceId: "",
        params: {
          define: {
            name: filename,
            url: "",
            sql: "",
            method: "GET",
            desc: "",
            datasourceId: "",
            parentId: null,
          },
          inputParameters: [],
          outputParameters: [],
          historyVersion: [],
        },
      });
    },
    /**
     * 监听 Workbench:add 事件，触发往worklist塞work的逻辑
     * @param {Work} option
     * @param {Funcion} cb
     * @return {Notice}
     */
    "Workbench:add"(option, cb) {
      if (!option.id || !option.filename) {
        this.$Notice.close("developerWarning");
        return this.$Notice.error({
          title: this.$t(
            "message.workBench.container.developerWarning.notice.title"
          ),
          desc: this.$t(
            "message.workBench.container.developerWarning.notice.desc"
          ),
          name: "developerWarning",
          duration: 5,
        });
      }

      option = {
        // owner: storage.get(WORKSPACEIDKEY, "cookie"),
        // code: this.sqlCode,
        ...option,
      };

      let work = null;

      // 如果已经在tabs中，则打开
      let repeatWork = find(this.worklist, (work) => work.id == option.id);
      if (!repeatWork) {
        if (this.worklist.length >= 20) {
          this.$Notice.close("boyondQuota");
          cb && cb(false);
          return this.$Notice.warning({
            title: this.$t("message.container.boyondQuota.title"),
            desc: this.$t("message.container.boyondQuota.desc"),
            name: "boyondQuota",
            duration: 5,
          });
        }
        work = new Work(option);

        // addWay用于判断新建脚本时脚本在tab栏打开的位置
        // follow表示紧跟上一个脚本
        if (option.addWay === "follow") {
          const index = findIndex(
            this.worklist,
            (item) => item.id === this.current
          );
          this.worklist.splice(index === -1 ? 0 : index + 1, 0, work);
        } else {
          this.worklist.push(work);
        }
        repeatWork = work;
      }
      this.chooseWork(repeatWork);
      cb && cb(true);
      if (option.tableId) {
        work.tableId = option.tableId;
      }
    },
    async "Workbench:save"({ pId, script }, cb) {
      let { define, inputParameters, outputParameters } = script.params;
      let { id, name, url, desc, method, parentId } = define;
      let work = find(this.worklist, (item) => item.id === this.current);
      let sql = script.data;
      if (pId) {
        parentId = pId;
      }
      let datasourceId = work.datasourceId;
      let params = {
        define: {
          id,
          name,
          url,
          datasourceId,
          desc,
          method: this.transformContextToBit(method),
          script:sql,
          parentId,
          workspaceId: storage.get(WORKSPACEIDKEY, "cookie") - 0,
        },
        inputParameters,
        outputParameters,
      };
      if (script.copy) {
        params.copy = script.copy;
      }
      this.closeModal.close();
      let { status, data, message } = await axios({
        method: "POST",
        url: `/api/rest_j/v1/acl/draft/flow`,
        data: {
          type: "api",
          source: params,
          workspaceId: storage.get(WORKSPACEIDKEY, "cookie") - 0,
          sourceId: id,
        },
      }).catch((err) => {
        console.log(err);
        this.$Message.error(err ? err.message : "保存失败");
        cb && cb(false);
      });

      if (status == 0) {
        this.$Message.success("保存成功");
        let index = findIndex(
          this.worklist,
          (item) => item.id === this.current
        );
        if (this.worklist[index].unsave) {
          this.worklist[index].unsave = false;
        }
        if (id) {
          if (name != this.worklist[index].filename) {
            //更新树上的名称
            this.dispatch("apiSidebar:updateLeafName", { id, name });
          }
          this["Workbench:updateTab"](
            {
              id: id,
              oldId: id,
            },
            cb
          );
          return;
        }
        this.dispatch("apiSidebar:refresh", (tree) => {
          //另存为之后先刷新树
          if (tree) {
            let temp = find(tree, (item) => {
              return item.parentId == parentId && item.name == name;
            });
            if (temp) {
              this["Workbench:updateTab"](
                {
                  id: temp.id,
                  oldId: this.current,
                },
                cb
              );
            }
          }
        });
      } else {
        cb && cb(false);
        this.$Message.error(message);
      }
    },
    transformContextToBit(context) {
      let v = 0;
      let b = 1 << methodList.indexOf(context);
      v = v | b;
      return v;
    },
    async latest(id, cb) {
      let { status, data, message } = await axios({
        method: "GET",
        url: `/api/rest_j/v1/acl/flow/latest?type=api&sourceIdList=${id}`,
      }).catch((err) => {
        cb(false);
        console.log(err);
      });
      if (status == 0) {
        let node = data.data[0] || {};
        let { source, flowStatus } = node;
        let params = JSON.parse(source);
        let { name, id, script:sql, method, datasourceId } = params.define;
        params.define.method = this.getConextFromNum(method);
        let res = await this.getHistoryVersion(id);
        let option1 = {
          id: id + "",
          filename: name,
          saveAs: true,
          flowStatus,
          workFlowId: node.id,
          code: sql,
          datasourceId,
          type: "apiScript",
          copy: params.copy,
          params: {
            ...params,
            historyVersion: (res.data && res.data.data) || [],
          },
        };
        cb(option1);
      } else {
        cb(false);
      }
    },
    async "Workbench:onLine"(script) {
      //发布上线
      const work = find(this.worklist, (item) => item.id === this.current);
      let params = script.params;
      let {
        id,
        parentId,
        url,
        method,
        desc,
        name,
        sql,
        workspaceId,
        datasourceId,
      } = params.define;
      method = this.transformContextToBit(method);
      let source = {
        define: {
          id,
          parentId,
          url,
          method,
          desc,
          name,
          script: sql,
          workspaceId,
          datasourceId,
        },
        inputParameters: params.inputParameters,
        outputParameters: params.outputParameters,
        copy: script.copy,
      };
      let { status, data, message } = await axios({
        method: "POST",
        url: "/api/rest_j/v1/acl/apply/flow",
        data: {
          type: "api",
          source,
          workspaceId: storage.get(WORKSPACEIDKEY, "cookie") - 0,
          workFlowId: work.workFlowId,
        },
      }).catch((err) => {
        this.$Message.error("上线申请失败");
        console.log(err);
      });
      if (status === 0) {
        this.$Message.success("上线申请成功，请联系管理员审批~");
        this["Workbench:updateTab"]({
          id: this.current,
          oldId: this.current,
        });
      } else {
        this.$Message.error(message);
      }
    },
    async getHistoryVersion(id) {
      return await axios({
        method: "GET",
        url: `/api/rest_j/v1/acl/flow/history?type=api&sourceId=${id}`,
      }).catch((err) => {
        cb(false);
        console.log(err);
      });
    },
    getConextFromNum(value) {
      let method = "";
      for (let i = 0; i < methodList.length; i++) {
        let b = 1 << i;
        if ((value & b) == b) {
          method = methodList[i];
        }
      }
      return method;
    },
    "Workbench:openFile"(option, cb) {
      let work = find(this.worklist, (item) => item.id == option.id);
      if (work) {
        this.chooseWork(work);
        return;
      }
      this.latest(option.id, (option1) => {
        this["Workbench:add"](option1, (f) => {});
      });
    },
    "Workbench:saveAs"(script, cb) {
      this.$refs.saveAs.open(script, cb);
    },
    "Workbench:updateTab"({ id, oldId }, cb) {
      this.latest(id, (option) => {
        const index = findIndex(this.worklist, (work) => {
          return work.id == oldId;
        });
        if (index >= 0) {
          this.worklist[index].filename = option.filename;
          this.worklist[index].workFlowId = option.workFlowId;
          if (id != oldId) {
            this.worklist[index].id = id + "";
            this.current = id + "";
          }
          this.dispatch(
            "Workbench:updateScript",
            {
              params: option.params,
              flowStatus: option.flowStatus,
              copy: option.copy,
              id: oldId
            },
            cb
          );
          this.chooseWork(this.worklist[index]);
        }
      });
    },
    "Workbench:checkExist"({ pId, filename }, cb) {
      this.dispatch("apiSidebar:getTreeList", (tree) => {
        let list = find(
          tree,
          (item) =>
            item.parentId === pId &&
            item.name === filename &&
            item.id !== this.current - 0
        );
        if (list) {
          cb && cb(true);
        } else {
          cb && cb(false);
        }
      });
    },
    "Workbench:pasteInEditor"(value, node = {}) {
      // node页面和scriptis页面操作不同，由于scriptis页面有缓存，所以关闭页面并不会注销组件，所以先判断是node页面触发的还是scriptis页面触发的，然后再判断是有那个编辑器触发的
      if (!this.node && Object.keys(node).length <= 0) {
        const work = find(this.worklist, (work) => work.id === this.current);
        if (!work)
          return this.$Message.warning(
            this.$t("message.workBench.container.warning.noSelectedScript")
          );
        this.dispatch("Workbench:insertValue", {
          id: this.current,
          value,
        });
      } else {
        const work = find(this.worklist, (work) => work.id === node.key);
        if (work && node.key === this.current) {
          this.dispatch("Workbench:insertValue", {
            id: node.key,
            value,
          });
        }
      }
    },
    // 用于获取当前打开的脚本里面有几种语言
    "Workbench:getWorksLangList"(cb) {
      const workLangList = uniq(this.worklist.map((item) => item.data.lang));
      cb(workLangList);
    },
    "Workbench:setTabPanelSize"() {
      this.isTopPanelFull = false;
    },
    "Workbench:removeWork"(work) {
      this.removeWork(work);
    },
    /**
     * 选中一个tab项
     * @param {Work} work
     */
    chooseWork(work) {
      if (work) {
        const type = work.type;
        // 选中work的时候先高亮work所属的模块树，然后去清除翻转过来的另一块文件树；
        // 由于模块间是使用v-if去切换的，所以会触发不到invert后的模块高亮请求
        this.dispatch(
          this.getMethodName({
            type,
            isInvert: false,
          }),
          work
        );
        this.dispatch(
          this.getMethodName({
            type,
            isInvert: true,
          }),
          ""
        );
        this.lastCurrent = this.current;
        this.current = work.id;
        // this.dispatch("IndexedDB:toggleTab", work.id);
        this.dispatch("Workbench:setParseAction", work.id);
        this.panelControl(
          this.isTopPanelFull ? "fullScreen" : "releaseFullScreen"
        );
      }
    },
    /**
     * 从worklist列表中移除work，对外抛出'Workbench:deleteDirOrFile'事件。
     * 如果work修改过未保存，则提示保存；如果saveAs是true，则提示另存。
     * @param {Work} work
     * @return {Promise}
     */
    removeWork(work) {
      return new Promise((resolve, reject) => {
        let doRemove = () => {
          let index = this.worklist.indexOf(work);
          if (index != -1) {
            this.worklist.splice(index, 1);
            // this.dispatch("IndexedDB:removeTab", work.id);
            // this.dispatch("IndexedDB:removeGlobalCache", {
            //   id: this.userName,
            //   tabId: work.id,
            // });
            // this.changeTabParams("change");
          }
          if (work.id == this.current) {
            if (this.workListLength > 0) {
              let findWork = last(this.worklist);
              this.current = findWork.id;
              let type = findWork.type;
              // 如果上一次选中的tab没被关闭，就跳回上一次选中的tab，否则则默认选中最后一个
              let index = this.worklist.findIndex(
                (work) => work.id === this.lastCurrent
              );
              if (index !== -1) {
                this.current = this.lastCurrent;
                type = this.worklist[index].type;
                findWork = this.worklist[index];
              }
              // 先设置当前脚本高亮
              this.dispatch(
                this.getMethodName({
                  type,
                  isInvert: false,
                }),
                findWork
              );
              /**
               * 清空另外一个模块的高亮，这里和上一次调用时互斥的
               * 因为不知道是工作空间还是HDFS处于打开状态，所以两次操作只执行用户看到的模块
               * 即设置或者清除当前用户能看到的模块高亮
               */
              this.dispatch(
                this.getMethodName({
                  type,
                  isInvert: true,
                }),
                ""
              );
              // this.dispatch("IndexedDB:toggleTab", this.current);
            } else {
              this.isTopPanelFull = false;
              this.current = "";
              this.dispatch("WorkSidebar:setHighLight", "");
              this.dispatch("HdfsSidebar:setHighLight", "");
            }
          }
          // 清空从全局历史转过来的脚本时，切换路由到/，否则刷新界面的时候会被一直打开
          if (work.id === this.$route.query.id) {
            this.$router.push("/");
          }
          resolve();
        };
        if (work.unsave) {
          this.chooseWork(work);
          this.showCloseModal = true;
          this.closeModal.cancel = () => {
            this.showCloseModal = false;
            this.close = () => {};
            this.save = () => {};
            this.saveAs = () => {};
            resolve();
          };
          this.closeModal.close = () => {
            this.showCloseModal = false;
            doRemove();
          };
          if (!work.saveAs) {
            this.closeModal.text = `${work.filename}-${this.$t(
              "message.workBench.container.removeWork.normal"
            )}`;
            this.closeModal.save = () => {
              this.showCloseModal = false;
              this.dispatch("Workbench:save", work.data);
              doRemove();
            };
            this.closeModal.saveAs = null;
          } else {
            const scriptText =
              work.type === "hdfsScript"
                ? `${work.filename}-${this.$t(
                    "message.workBench.container.removeWork.readOnly"
                  )}`
                : `${work.filename}-${this.$t(
                    "message.workBench.container.removeWork.temporary"
                  )}`;
            this.closeModal.text = scriptText;
            this.closeModal.save = null;
            this.closeModal.saveAs = () => {
              this.dispatch("Workbench:saveAs", work.data);
            };
          }
        } else {
          doRemove();
        }
      });
    },
    /**
     * 按照类型关闭tab
     *  @param {String} name
     */
    async closeTabs(name) {
      let needCloseTabs = [];
      switch (name) {
        case "other":
          this.worklist.forEach((work) => {
            if (work.id != this.current) {
              needCloseTabs.push(work);
            }
          });
          break;
        case "all":
          needCloseTabs = this.worklist.slice(0);
          break;
        case "left":
          for (let i = 0; i < this.workListLength; i++) {
            if (this.worklist[i].id != this.current) {
              needCloseTabs.push(this.worklist[i]);
            } else {
              break;
            }
          }
          break;
        case "right":
          for (let i = this.workListLength - 1; i > 0; i--) {
            if (this.worklist[i].id != this.current) {
              needCloseTabs.push(this.worklist[i]);
            } else {
              break;
            }
          }
          break;
      }
      for (const work of needCloseTabs) {
        await this.removeWork(work);
      }
    },
    getSourceId(id) {
      const index = findIndex(
        this.worklist,
        (work) => work.id === this.current
      );
      this.worklist[index].datasourceId = id;
    },

    // // 获取高亮的方法名
    getMethodName(args) {
      let { type, isInvert } = args;
      const lib = {
        workspaceScript: "WorkSidebar:setHighLight",
        hdfsScript: "HdfsSidebar:setHighLight",
      };
      if (isInvert) {
        type = type === "workspaceScript" ? "hdfsScript" : "workspaceScript";
      }
      return lib[type];
    },

    changeTabParams(type) {
      if (this.workListLength > this.tabMove.maxTabLen) {
        if (type === "init") {
          this.tabMove.rightTab = this.workListLength - this.tabMove.maxTabLen;
          this.tabMove.leftTab = 0;
        } else {
          this.tabMove.leftTab = this.workListLength - this.tabMove.maxTabLen;
          this.tabMove.rightTab = 0;
        }
        this.handleTabShowOrHidden();
        this.isControlBtnShow = true;
      } else {
        this.tabMove.leftTab = 0;
        this.tabMove.rightTab = 0;
        this.isControlBtnShow = false;
        if (type !== "init") {
          this.handleTabShowOrHidden();
        }
      }
    },

    tabMoving(type) {
      if (type === "right" && this.tabMove.leftTab >= 1) {
        this.tabMove.leftTab -= 1;
        this.tabMove.rightTab += 1;
      } else if (type === "left" && this.tabMove.rightTab >= 1) {
        this.tabMove.leftTab += 1;
        this.tabMove.rightTab -= 1;
      }
      this.handleTabShowOrHidden();
    },

    handleTabShowOrHidden() {
      this.worklist.forEach((o, index) => {
        if (this.tabMove.leftTab > 0 && index <= this.tabMove.leftTab - 1) {
          o.isShow = false;
        } else if (
          this.tabMove.rightTab > 0 &&
          index > this.workListLength - this.tabMove.rightTab - 1
        ) {
          o.isShow = false;
        } else {
          o.isShow = true;
        }
      });
    },

    panelControl(name) {
      if (name === "fullScreen") {
        this.isTopPanelFull = true;
      } else {
        this.isTopPanelFull = false;
      }
      this.dispatch("Workbench:setEditorPanelSize", {
        id: this.current,
        status: name,
      });
    },
    dropdownClick(name) {
      const closeMenuList = ["fullScreen", "releaseFullScreen"];
      if (closeMenuList.indexOf(name) === -1) {
        this.closeTabs(name);
      } else {
        this.panelControl(name);
      }
    },

    updateApiName(updateName) {
      const index = findIndex(
        this.worklist,
        (item) => item.id === this.current
      );
      this.worklist[index].filename = updateName;
    },
    handleismodifyByOldTab() {
      const index = findIndex(
        this.worklist,
        (item) => item.id === this.current
      );
      this.worklist[index].ismodifyByOldTab = true;
    },
  },
};
</script>
<style src="./index.scss" lang="scss"></style>

